import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    maxWidth: 800,
    margin: '0 auto',
  },
  title: {
    textAlign: 'center',
    marginBottom: theme.spacing(1),
    fontWeight: 600,
    fontSize: '1rem',
  },
  text: {
    textAlign: 'center',
    marginBottom: theme.spacing(1),
    fontSize: '1rem',
  },
  paper: {
    padding: 0,
    border: '1px solid #e0e0e0',
    overflow: 'hidden',
    minWidth: '470px',
  },
  row: {
    padding: 0,
    margin: 0,
    minHeight: '36px',
    maxHeight: '36px',
    borderBottom: '1px solid #e0e0e0',
    width: '100%',
    '&:last-child': {
      borderBottom: 'none',
    },
    '& .MuiGrid-item': {
      padding: '0 8px !important',
    },
  },
  textColumn: {
    display: 'flex',
    alignItems: 'center',
    height: '36px',
  },
  bodyText: {
    fontSize: '0.938rem !important',
    lineHeight: '1 !important',
  },
  unlinkText: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(0.5),
    lineHeight: 1,
  },
}));
